import { render, staticRenderFns } from "./KitchenChargeLineGroups.vue?vue&type=template&id=60beb691&scoped=true"
import script from "./KitchenChargeLineGroups.vue?vue&type=script&lang=js"
export * from "./KitchenChargeLineGroups.vue?vue&type=script&lang=js"
import style0 from "./KitchenChargeLineGroups.vue?vue&type=style&index=0&id=60beb691&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60beb691",
  null
  
)

export default component.exports